export default __webpack_public_path__ + "static/media/working.b0322547.svg";